import React from 'react';
import './Home.css';
import Typed from 'react-typed';
import { FaFacebookF, FaLinkedinIn, FaGithub, FaInstagram, FaTwitter } from 'react-icons/fa';
import MouseParticles from 'react-mouse-particles';
import ParticlesBg from 'particles-bg';


const Home = () => {

    return (
        <>

            <div className="home">
                <div className="row">
                    <div className="col-md-6">
                        <div className="py-5 d-flex justify-content-center image-area">
                            <img src="https://i.ibb.co/BL6V9Ty/image-12.png" style={{ borderRadius: '30px' }} alt="" />
                        </div>
                    </div>

                    <div className="col-md-6 d-flex align-items-center justify-content-center">
                        <div className="text-area mt-3">
                            <h2>Hi, This is </h2>
                            <h1><span className='text'>Nazmus Sakib</span></h1>

                            <h3>
                                <Typed
                                    strings={['Frontend Developer', 'Programmer', 'Software Engineer', 'Dreamer']}
                                    typeSpeed={40}
                                    backSpeed={40}
                                    loop
                                />
                            </h3>
                            <p className="text-justify text-capitalize">An enthusiast frontend developer 🚀 Having an
                            experience Of Building Dynamic Web Applications With JavaScript
                            and other cool libraries and frameworks.
                        </p>
                            <button className="m-2 mb-3 mediaBtn">
                                <a href="https://drive.google.com/file/d/1MInbYT_Ol9uK16KeFv4CuhzJ7DxRW3ZV/view?usp=sharing" target="_blank" rel="noreferrer noopener">Download CV</a>

                            </button>
                            <div className="m-2 ">
                                <a href="https://www.facebook.com/sakib752" target="_blank" className='mx-2' rel="noopener noreferrer">
                                    <FaFacebookF size='2rem' />
                                </a>
                                <a href="https://www.linkedin.com/in/nazmus-sakib-developer/" target="_blank" className='mx-2' rel="noreferrer">
                                    <FaLinkedinIn size='2rem' />
                                </a>
                                <a href="https://github.com/saakeeb" target="_blank" className='mx-2' rel="noopener noreferrer">
                                    <FaGithub size='2rem' />
                                </a>
                                <a href="https://www.instagram.com/n_saakeeb/" target="_blank" className='mx-2' rel="noopener noreferrer">
                                    <FaInstagram size='2rem' />
                                </a>
                                <a href="https://twitter.com/Saakeeb" target="_blank" className='mx-2' rel="noopener noreferrer">
                                    <FaTwitter size='2rem' />
                                </a>
                            </div>
                        </div>



                    </div>
                </div>

            </div>
            <MouseParticles g={1} color="random" cull="col,image-wrapper" />
            <ParticlesBg num={50} type="cobweb" bg={true} />

        </>
    );
};

export default Home;